import { IAnswer } from '@/services/FormStructure';
import Conditional from './conditionals/Conditional';

export interface IComponentContent {
    title: string;
    description: string;
    value?: string;
    options?: string[];
}

export interface IComponentSettings {
    description?: boolean;
    isShuffled?: boolean;
    lockLastOption?: boolean;
    isMainQuestion?: boolean;
    isRequired?: boolean;
    numericButtonConfiguration?: {
        startAndFinish: {
            start: number;
            finish: number;
        };
        methodology: string;
    };
    imageData?: {
        image: string;
        imageName: string;
        width?: number;
    };
    methodology?: string;
    placeholder?: string;
    numberOfOptions?: number;
    minCharacter?: number;
    radioSettings?: {
        questionsText: [
            {
                question: string;
            },
        ];
        radioOptions: [
            {
                text: string;
                value: number;
            },
        ];
    };
    selectionStrategy?: 'single' | 'multiple';
    childrenType?: string;
    parameter?: string;
}

export interface IComponentStyle extends ColumnStyle {
    size?: {
        width: string;
        height: string;
    };
}

export interface ColumnStyle {
    alignment?: 'left' | 'center' | 'right';
}

export interface IBaseComponent {
    content: IComponentContent;
    id: number;
    ui_id?: number;
    type: string;
    isQuestion: boolean;
    answer?: IAnswer | IAnswer[];
    parentId?: number;
}

export interface IBaseComponentAndStyle extends IBaseComponent {
    settings: IComponentSettings;
    style: IComponentStyle;
    conditionals?: Conditional[];
    children: IBaseComponent[];
}

export enum FormComponentsType {
    ImageComponent = 'ImageComponent',
    LikeDislikeComponent = 'LikeDislikeComponent',
    NumericButtonComponent = 'NumericButtonComponent',
    EmojiComponent = 'EmojiComponent',
    FreeTextComponent = 'FreeTextComponent',
    SimpleTextComponent = 'SimpleTextComponent',
    NumbersComponent = 'NumbersComponent',
    ButtonSelectComponent = 'ButtonSelectComponent',
    RadioButtonComponent = 'RadioButtonComponent',
    ParentGroupComponent = 'ParentGroupComponent',
    ParameterQuestionComponent = 'ParameterQuestionComponent',
}

// Os componentes de `basic/` (FreeText, Image) não existem em form_questions: o back-end devolve
// o elementId no lugar do questionId, e as duas sequências são independentes. Por isso o `id`
// deles pode coincidir com o `id` de uma pergunta, e só pode ser comparado com um questionId
// quando esta função devolve true.
//
// Atenção: isto não é o campo `isQuestion` do payload. O ParentGroupComponent vem com
// `isQuestion: false` (ele não guarda resposta própria, só os filhos), mas o `id` dele vem de
// form_questions, então aqui ele conta como componente de questão.
export const NON_QUESTION_COMPONENT_TYPES: string[] = [FormComponentsType.FreeTextComponent, FormComponentsType.ImageComponent];

export function isQuestionComponent(component: { type: string }): boolean {
    return !NON_QUESTION_COMPONENT_TYPES.includes(component.type);
}
